import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { VirtualKeyboardService } from '../virtual-keyboard/virtual-keyboard.service';

const LONG_PRESS_DELAY = 500;

@Component({
  selector: 'i-virtual-keyboard-key',
  templateUrl: './virtual-keyboard-key.component.html',
  styleUrls: ['./virtual-keyboard-key.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VirtualKeyboardKeyComponent implements OnInit {
  @Input() key: string;
  @Input() special: string;
  @Input() selected: boolean;

  private hook: (key: string, long: boolean) => void;
  private beginTimeStamp: number;
  private wasDown: boolean = false;

  constructor(private virtualKeyboardService: VirtualKeyboardService) {}

  ngOnInit() {
    this.hook = this.virtualKeyboardService.registerKey();
  }

  begin(e: MouseEvent | TouchEvent) {
    this.beginTimeStamp = e.timeStamp;
    this.wasDown = true;
  }

  click(e: MouseEvent | TouchEvent) {
    if (!this.wasDown) return;
    else this.wasDown = false;
    const long = e.timeStamp - this.beginTimeStamp > LONG_PRESS_DELAY;
    if (this.special) {
      this.hook(this.special, long);
    } else {
      this.hook(this.key, long);
    }
  }
}
